function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  padding: 16px;\n  border-radius: 8px;\n  margin: 16px 0;\n  font-size: 14px;\n  line-height: 1.5;\n  \n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
var MessageContainer = styled.div(_templateObject(), function(param) {
    var _param_type = param.type, type = _param_type === void 0 ? 'info' : _param_type;
    switch(type){
        case 'info':
            return "\n          background-color: #eff6ff;\n          color: #2563eb;\n          border: 1px solid #bfdbfe;\n        ";
        case 'success':
            return "\n          background-color: #f0fdf4;\n          color: #16a34a;\n          border: 1px solid #bbf7d0;\n        ";
        case 'warning':
            return "\n          background-color: #fffbeb;\n          color: #ca8a04;\n          border: 1px solid #fde68a;\n        ";
        case 'error':
            return "\n          background-color: #fef2f2;\n          color: #dc2626;\n          border: 1px solid #fecaca;\n        ";
        default:
            return '';
    }
});
export var FeedbackMessage = function(param) {
    var message = param.message, _param_type = param.type, type = _param_type === void 0 ? 'info' : _param_type, className = param.className;
    return /*#__PURE__*/ React.createElement(MessageContainer, {
        type: type,
        className: className
    }, message);
};
export default FeedbackMessage;
